import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function RequireAuth({ children, role }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const loc = useLocation();
  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#F8F7F4] flex items-center justify-center" data-testid="auth-checking">
        <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-[#8A9992]">Checking session…</div>
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace state={{ from: loc.pathname + loc.search }} />;
  }
  if (role && user.role !== role) {
    return (
      <div className="min-h-screen bg-[#F8F7F4] flex items-center justify-center p-8" data-testid="auth-forbidden">
        <div className="hard-border bg-white p-8 max-w-md text-center">
          <div className="mono-label text-[#8B2B3A]">Access denied</div>
          <p className="mt-3 text-[#0A140F]">Your role doesn't have permission to view this page.</p>
        </div>
      </div>
    );
  }
  return children;
}
